import './news-overlay.scss'

const animationDuration = 300;

function addElement(parent = false, tag = "div", className = '', innerHTML = false) {
  const element = document.createElement(tag);
  if(className) element.classList.add(className);
  if(innerHTML) element.innerHTML = innerHTML;
  if(parent) parent.append(element);
  return element;
}



const loader = document.createElement('div');
loader.classList.add('news-overlay__loader');
loader.innerHTML = (`<div><div>★</div></div><span>Loading&hellip;</span>`);

const Container = (options = {}) => {

  const containerElement    = addElement(false,'div','news-overlay__container');
  const contentWraper       = addElement(containerElement,'div','news-overlay__content-wraper');
  const contentContainer    = addElement(contentWraper,'div','news-overlay__content-container');

  let currentContent;

  const closeText = options.closeTxt || "zamknij";
  const closeBtn = addElement(containerElement,'button','news-overlay__close-btn',closeText);
  closeBtn.dataset.newsOverlayAction = 'close';

  function open(callback = false) {
    document.body.style.overflow = "hidden";
    document.body.append(containerElement);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        containerElement.classList.add('news-overlay__content--on')
        if(typeof callback == "function") callback(contentContainer)
      })
    });
  }

  function close(callback = false){
    containerElement.classList.remove('news-overlay__content--on');
    setTimeout(() => {
      containerElement.remove();
      contentContainer.innerHTML = "";      
      if(typeof callback == "function") callback(contentContainer);
      if(currentContent && currentContent.onRemove)  currentContent.onRemove(); 
      currentContent = undefined;
      document.body.style.overflow = "auto";
    },animationDuration)
  }

  function setContent(content = false) {
    if(currentContent && currentContent.onRemove) currentContent.onRemove(); 
    if(content && content instanceof HTMLElement) { 
      contentContainer.innerHTML = ""
      contentContainer.append(content)
      currentContent = content;
    }
  } 

  return {
    open,
    close,
    setContent,
    container:containerElement,
  }

}

let currentState = {
  title : document.title,
  url: window.location.href,
}

const PostContainer = () => {

  const postContainer =             addElement(false,'div','news-overlay__post-conteiner');
  const nextPostLinkContainer =     addElement(postContainer,'div','news-overlay__next-post-link-container');
  const postContent =               addElement(postContainer,'div','news-overlay__post-content');
  const prevPostLinkContainer =     addElement(postContainer,'div','news-overlay__prev-post-link-container');
  const nextPostLink =              addElement(false,'a','news-overlay__next-post-link',` <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 100"><path fill="none" stroke="#000" stroke-miterlimit="10" d="M24.5 2.3l-19 48.2 19 48.2"/></svg>`);
  const prevPostLink =              addElement(false,'a','news-overlay__prev-post-link',` <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 100"><path fill="none" stroke="#000" stroke-miterlimit="10" d="M24.5 2.3l-19 48.2 19 48.2"/></svg>`);

  

  postContainer.append(loader);

  const handleClick = e => {
    e.preventDefault();
    const newPostID = e.currentTarget.dataset.postId;
    postContainer.loadPost(newPostID, (data) => {
      const newHistoryEntry = {type:"post", ID :newPostID }
      window.history.pushState( newHistoryEntry, data.title, data.url);
    });
  }

  nextPostLink.addEventListener('click', handleClick)
  prevPostLink.addEventListener('click', handleClick)

  function updatePostNavLink(container,link,post) {
    if(!post) {
      link.remove();
      return false;
    }
    link.dataset.postId = post.ID;
    link.setAttribute("href",post.permalink);
    //link.innerText = post.text;
    container.append(link);
  }

  postContainer.loadPost = function(postID, callback = function(){}) {
    if(!window.restURL) return false;
    postContainer.classList.remove('news-overlay__post-content--loaded')
    const endpoint = `${window.restURL}rh/v2/news/${postID}`;
    fetch(endpoint).then(response => response.json()).then(data => {
      postContent.innerHTML = data.content;
      const image = postContent.querySelector('img')
      image.addEventListener('load', e =>  {
        postContainer.classList.add('news-overlay__post-content--loaded')
      });
      updatePostNavLink(nextPostLinkContainer,nextPostLink,data.next)
      updatePostNavLink(prevPostLinkContainer,prevPostLink,data.prev)   
      callback(data);
    });
  }

  postContainer.onRemove = function() {
    /* nextPostLink.removeEventListener('click',handleClick);
    prevPostLink.removeEventListener('click',handleClick); */
    
  }

  return postContainer;
}

export default (options = {}) => {

  const popup = new Container();

  const handlePopstate = e => {
    if(e.state && e.state.type == "post") {
      const post = new PostContainer();
      popup.setContent(post);
      post.loadPost(e.state.ID);
      popup.open();
    } else {
      hide();
    }
  }

  window.addEventListener("popstate", handlePopstate);

  popup.container.addEventListener('click', e => {
    let action = e.target.dataset.newsOverlayAction;
    if(!action) {
      const actionElement = e.target.closest('[data-news-overlay-action]');
      action = actionElement && actionElement.dataset.newsOverlayAction;
    }
    if(!action) return false;
    e.preventDefault();
    if(action == 'close') { 
      hide();
      window.history.pushState({type:""},currentState.title,currentState.url)
    }
  })

  const show = (content) => {
    popup.open();
  }

  const hide = () => {
    popup.close();
  }

  const load = () => show();

  const loadPost = (postID) => {
    const post = new PostContainer();
    popup.setContent(post);
    post.loadPost(postID, (data) => {
      const newHistoryEntry = {type:"post", ID :postID }
      window.history.pushState( newHistoryEntry, data.title, data.url);
    });
    popup.open();
  }

  const newsOverlay = {
    show,
    hide,
    loadPost,
    load,
  }
  return newsOverlay
}
